<template>
  <widget-temp widgetTitle="Báo cáo tình trạng xe hàng" widgetName="TruckStatusChart" v-bind:widgetId="3">
    <template slot="widget-content">
      <div class="chart-container">
        <highcharts :options="chartOptions"></highcharts>
      </div>
    </template>
  </widget-temp>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "truck-status-chart",
  data() {
    return {};
  },
  computed: {
    ...mapState({
      loading: state => state.dashboard.loading,
      truckData: state => state.dashboard.truck_status_chart
    }),
    chartOptions() {
      return {
        chart: {
          type: 'pie',
          height: 400
        },
        title: {
          text: ''
        },
        tooltip: {
          pointFormat: '<b>{point.y}</b> xe ({point.percentage:.1f}%)'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '<b>{point.name}</b>: {point.y} xe ({point.percentage:.1f}%)'
            },
            showInLegend: true
          }
        },
        series: [{
          name: 'Số lượng xe',
          colorByPoint: true,
          data: this.truckData
        }],
        credits: {
          enabled: false
        }
      };
    }
  },
  methods: {
    async getChartData() {
      this.$store.dispatch("dashboard/getTruckStatusChart");
    }
  },
  mounted() {
    this.getChartData();
  }
};
</script>

<style scoped>
.chart-container {
  padding: 20px;
  min-height: 400px;
}
</style>
